<template>
  <td
    class="t-table-v2__cell"
    :class="classes"
  >
    <slot></slot>
  </td>
</template>

<script>
import TableCellMixin from '../../mixins/TableCellMixin';

export default {
  name: 't-table-v2-cell',
  mixins: [TableCellMixin],
  inject: ['$expanded'],
  computed: {
    expanded() {
      return this.$expanded();
    },
    classes() {
      const classes = [
        `t-table-v2__cell--${this.contentAlign}`,
      ];

      if (this.expanded) {
        classes.push('t-table-v2__cell--expanded');
      }

      if (this.noWrap) {
        classes.push('t-table-v2__cell--no-wrap');
      }

      return classes;
    },
  },
};
</script>
